import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import api from "@/utils/api";

const PAGE_TITLES = {
  "/dashboard": "¿En qué debería trabajar hoy?",
  "/radar": "Radar de Procesos",
  "/favoritos": "Mis Favoritos",
  "/alertas": "Centro de Alertas",
  "/perfil": "Perfil Empresarial",
  "/usuarios": "Gestión de Usuarios",
  "/configuracion": "Configuración SECOP",
  "/health": "Health Check del Sistema",
};

export default function Layout({ children }) {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [unreadAlerts, setUnreadAlerts] = useState(0);

  const pageTitle = PAGE_TITLES[location.pathname] || "";

  useEffect(() => {
    const fetchUnread = () => {
      api.get("/alerts/unread-count")
        .then((r) => setUnreadAlerts(r.data.unread_count || 0))
        .catch(() => {});
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 60000);
    return () => clearInterval(interval);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <div className="flex h-screen bg-[#080C14] overflow-hidden">
      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-20 lg:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`${
          mobileOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 fixed lg:relative z-20 h-full transition-transform duration-300`}
      >
        <Sidebar
          collapsed={collapsed}
          onToggle={() => setCollapsed(!collapsed)}
          unreadAlerts={unreadAlerts}
        />
      </div>

      {/* Main */}
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <TopBar
          unreadAlerts={unreadAlerts}
          onMobileMenuToggle={() => setMobileOpen(!mobileOpen)}
          pageTitle={pageTitle}
        />
        <main className="flex-1 overflow-y-auto">
          {children || <Outlet />}
        </main>
      </div>
    </div>
  );
}
